var exports = {
  "UT": "MenuItems.module__roleIcon___d04zZ2",
  "yk": "MenuItems.module__roleContainer___d04zZ2",
  "S3": "MenuItems.module__roleName___d04zZ2",
  "nT": "MenuItems.module__roleDisabled___d04zZ2",
  "u8": "MenuItems.module__readonlyRoleItem___d04zZ2",
  "zQ": "MenuItems.module__readonlyRoleSpacer___d04zZ2",
  "ec": "MenuItems.module__flexColumn___d04zZ2",
  "Kk": "MenuItems.module__icon___d04zZ2",
  "Bx": "MenuItems.module__iconSmall___d04zZ2",
};

module.exports = exports;
